<template>
  <div class="content" v-if="portfolioPage">
    <div class="inner">
      <div class="heading">{{ portfolioPage.sub_heading }}</div>
      <div class="categories">
        <page-link :key="service.ItemID" :to="service.url" v-for="service in services">
          <img :alt="service.name" :src="service.image" v-if="service.image" />
          <span>{{ service.name }}</span>
        </page-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["portfolioPage"]),
    services() {
      if (!this.portfolioPage) return []
      return this.portfolioPage.subs
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 7rem 0;
  padding-bottom: 0;
  clear: both;
  font-size: 2rem;
}
.content p {
  padding-bottom: 3rem;
}
.content p a {
  color: #c1d62f;
}

.categories {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 3rem;
  margin: 7rem 0;
  margin-top: 2rem;
}
.categories a {
  position: relative;
  overflow: hidden;
}
.categories img {
  transition: all 0.3s;
}

.categories a:hover img {
  transform: scale(1.1);
}

.categories a span {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 2rem;
  font-size: 3rem;
  background-color: rgba(0, 0, 0, 0.76);
  transition: all 0.3s;
}
.categories a:hover span {
  background-color: rgba(193, 214, 47, 0.86);
  padding: 3rem 2rem;
}

@media screen and (max-width: 950px) {
  .categories {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 650px) {
  .categories {
    grid-template-columns: repeat(2, 1fr);
  }
  .heading {
    font-size: 3rem;
  }
  .categories a span {
    font-size: 2.25rem;
  }
}
</style>
